/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import JobListOffCanvas from '../../components/jobs/JobListOffCanvas';
import JobDetailsOffCanvas from '../../components/jobs/JobDetailsOffCanvas';
import JobListContent from '../../components/jobs/JobListContent';
import QuestionnairesSection from '../../components/questionnaires/QuestionnairesSection';
import Spinner from '../../components/Spinner';
import { UserData, JobData } from '../../api/JobsService';

interface QuestionnairePageProps {
  questionnaireData: any;
  users: Record<number, UserData>;
  loadingUsers: boolean;
  jobData: any; 
  jobQuestionnaireData: any;
  selectedQuestionnaireId: string | null;
  setSelectedQuestionnaireId: (id: string | null) => void;
  paginatedQuestionnaires: any[];
  paginatedJobsEligible: any[];
  eligibleJobs: any[];
  questionnaireCurrentPage: number;
  setQuestionnaireCurrentPage: (page: number) => void;
  jobCurrentPage: number;
  totalPages: number;
  itemsPerPage: number;
  handlePageSizeChange: (size: number) => void;
  handleJobPageChange: (page: number) => void;
  handlePreview: (id: string) => void;
  handleAddToJob: (index: number, id: string) => void;
  isFilteringJobs: boolean;
  PAGE_SIZE_OPTIONS: number[];
  openApiJobs: JobData[];
  jobQuestionnaireMap: Map<number, string>;
  onSetDefault?: (questionnaireId: string) => void;
  onRemoveDefault?: (questionnaireId: string) => void;
  hasDefaultQuestionnaire?: boolean;
  // VI-579 follow-up: pass through the count updater ref so QuestionnairesSection can register
  // its real handler with Home for cross-component count updates (Bugs 1 + 3).
  activeJobsCountUpdaterRef?: React.MutableRefObject<
    (questionnaireId: string, change: { delta?: number; absolute?: number }) => void
  >;
  // VI-579 follow-up: true while Home's cold-path attached-jobs preload is in flight.
  // Gates the JobListContent job list behind the existing big spinner so the drawer never
  // shows partial data first. Cache hits / stale-cache hydration keep this false.
  isLoadingDrawerAttachedJobs?: boolean;
  relationshipManagerEmail?: string | null;
}

// receive props from Home.tsx
// previously this was implemenetd in Home.tsx, but now we are moving it to QuestionnairePage.tsx
const QuestionnairePage: React.FC<QuestionnairePageProps> = ({
  questionnaireData,
  users,
  loadingUsers,
  jobData,
  jobQuestionnaireData,
  selectedQuestionnaireId,
  setSelectedQuestionnaireId,
  paginatedQuestionnaires,
  paginatedJobsEligible,
  eligibleJobs,
  questionnaireCurrentPage,
  setQuestionnaireCurrentPage,
  jobCurrentPage,
  totalPages,
  itemsPerPage,
  handlePageSizeChange,
  handleJobPageChange,
  handlePreview,
  handleAddToJob,
  isFilteringJobs,
  PAGE_SIZE_OPTIONS,
  openApiJobs,
  jobQuestionnaireMap,
  onSetDefault,
  onRemoveDefault,
  hasDefaultQuestionnaire,
  activeJobsCountUpdaterRef,
  isLoadingDrawerAttachedJobs,
  relationshipManagerEmail,
}) => {

  if (questionnaireData.loading) {
    const isMobile = window.innerWidth < 768;
    return (
      <div style={{ 
        height: '50vh',
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Spinner size={isMobile ? 'md' : 'xl'} />
      </div>
    );
  }

  if (questionnaireData.error) {
    return (
      <div className="mt-2 mb-2 text-center">
        <img 
          src="/svgs/no-results.svg" 
          alt="No questionnaires found" 
        />
      </div>
    );
  }

  return (
    <div>
      <div className='app-container min-vh-100 d-flex flex-column py-3 px-1'>
        {/* Questionnaires section */}
        <QuestionnairesSection
          questionnaires={paginatedQuestionnaires}
          onAddToJob={handleAddToJob}
          onPreview={handlePreview}
          onStatusChange={questionnaireData.handleStatusChange}
          onSetDefault={onSetDefault}
          onRemoveDefault={onRemoveDefault}
          hasDefaultQuestionnaire={hasDefaultQuestionnaire}
          currentPage={questionnaireCurrentPage}
          totalPages={totalPages}
          onPageChange={setQuestionnaireCurrentPage}
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          users={users}
          loadingUsers={loadingUsers}
          openApiJobs={openApiJobs}
          jobQuestionnaireMap={jobQuestionnaireMap}
          activeJobsCountUpdaterRef={activeJobsCountUpdaterRef}
        />
      </div>
      
      {/* Job List Off Canvas */}
      <JobListOffCanvas 
        isOpen={jobQuestionnaireData.isOffCanvasOpen} 
        onClose={jobQuestionnaireData.handleCloseOffCanvas}
        title="Select Job"
        totalItems={eligibleJobs?.length || 0}
        itemsPerPage={itemsPerPage}
        onPageChange={handleJobPageChange}
      >
        <JobListContent
          isLoadingJobs={isFilteringJobs}
          isLoadingJobQuestionnaires={false}
          isLoadingAttachedJobs={isLoadingDrawerAttachedJobs}
          jobsError={jobData.jobsError}
          apiJobs={jobData.apiJobs}
          filteredJobs={paginatedJobsEligible}
          searchKeyword={jobData.searchKeyword}
          selectedDivision={jobData.selectedDivision}
          selectedUser={jobData.selectedUser}
          fetchJobs={jobData.fetchJobs}
          handleSearch={jobData.handleSearch}
          handleStaticJobClick={jobData.handleStaticJobClick}
          handleJobClick={jobData.handleJobClick}
          handleActionClick={jobQuestionnaireData.handleActionClick}
          getActionButtonText={jobQuestionnaireData.getActionButtonText}
          getActionButtonVariant={jobQuestionnaireData.getActionButtonVariant}
          associatingJobs={jobQuestionnaireData.associatingJobs}
          relationshipManagerEmail={relationshipManagerEmail}
        />
      </JobListOffCanvas>
      
      {/* Job Details Off Canvas Component */}
      <JobDetailsOffCanvas
        isOpen={jobData.isJobDetailsOpen}
        onClose={jobData.closeJobDetails}
        jobDetails={jobData.selectedJob || undefined}
        closeAllOffCanvas={() => {
          jobData.setIsJobDetailsOpen(false);
          jobQuestionnaireData.setIsOffCanvasOpen(false);
        }}
      />
    </div>
  );
};

export default QuestionnairePage;